/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationMarkReadRequest } from '../models/NotificationMarkReadRequest';
import type { PaginatedResponse_NotificationResponse_ } from '../models/PaginatedResponse_NotificationResponse_';
import type { UnreadCountResponse } from '../models/UnreadCountResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * 내 알림 목록 조회
     * 현재 로그인한 사용자의 알림 목록을 조회합니다.
     * @returns PaginatedResponse_NotificationResponse_ OK
     * @throws ApiError
     */
    public static appsNotificationViewsGetMyNotifications({
        orgId,
        workspaceId,
        notificationType,
        isRead,
        page = 1,
        perPage = 20,
    }: {
        /**
         * 기관 ID 필터
         */
        orgId?: (string | null),
        /**
         * 워크스페이스 ID 필터
         */
        workspaceId?: (string | null),
        /**
         * 알림 유형 필터
         */
        notificationType?: (string | null),
        /**
         * 읽음 여부 필터
         */
        isRead?: (boolean | null),
        /**
         * 페이지 번호
         */
        page?: number,
        /**
         * 페이지당 항목 수
         */
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_NotificationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/',
            query: {
                'org_id': orgId,
                'workspace_id': workspaceId,
                'notification_type': notificationType,
                'is_read': isRead,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * 읽지 않은 알림 개수 조회
     * 읽지 않은 알림 개수를 조회합니다.
     * @returns UnreadCountResponse OK
     * @throws ApiError
     */
    public static appsNotificationViewsGetUnreadCount(): CancelablePromise<UnreadCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/unread-count',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * 알림 읽음 처리
     * 선택한 알림들을 읽음 처리합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsNotificationViewsMarkNotificationsRead({
        requestBody,
    }: {
        requestBody: NotificationMarkReadRequest,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/mark-read',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * 모든 알림 읽음 처리
     * 모든 알림을 읽음 처리합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsNotificationViewsMarkAllNotificationsRead(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/mark-all-read',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
}
